module.exports = __webpack_public_path__ + "static/reviews-tab-edit-product-view-html-cfd59f0851a866d8b7450f5d6018e83b.png";